export default __webpack_public_path__ + "static/media/ki.a69ecd18.svg";